export const AGENT = parseInt(import.meta.env.VITE_APP_ROLE_AGENT);
export const CLIENT_EMPLOYEE = parseInt(import.meta.env.VITE_APP_ROLE_CLIENT_EMPLOYEE);
export const MANAGER = parseInt(import.meta.env.VITE_APP_ROLE_MANAGER);
export const ORGANIZATION_AGENT = parseInt(import.meta.env.VITE_APP_ROLE_ORGANIZATION_AGENT);
export const ORGANIZATION_MANAGER = parseInt(import.meta.env.VITE_APP_ROLE_ORGANIZATION_MANAGER);
export const OWNER = parseInt(import.meta.env.VITE_APP_ROLE_OWNER);
export const PURCHASED_LIST_ONLY = parseInt(import.meta.env.VITE_APP_ROLE_PURCHASED_LIST_ONLY);
export const SUPERVISOR = parseInt(import.meta.env.VITE_APP_ROLE_SUPERVISOR);
export const SUPER_ADMIN = parseInt(import.meta.env.VITE_APP_ROLE_SUPER_ADMIN);

export const All = [
	AGENT,
	CLIENT_EMPLOYEE,
	MANAGER,
	ORGANIZATION_AGENT,
	ORGANIZATION_MANAGER,
	OWNER,
	PURCHASED_LIST_ONLY,
	SUPERVISOR,
	SUPER_ADMIN,
]
